
import * as defaultImport from "@splunk/visualization-context/IconContext";
export * from "@splunk/visualization-context/IconContext";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
